<template>
  <div class="login_info_box">
    <div class="login_info_box_item">
      <div>{{ $t('login.user_name') }}</div>
      <div>
        <el-input :placeholder="$t('login.enter_user_name')" v-model="loginForm.loginName" clearable></el-input>
      </div>
    </div>
    <div class="login_info_box_item">
      <div>{{ $t('login.password') }}</div>
      <div>
        <el-input :placeholder="$t('login.enter_password')" v-model="loginForm.password" show-password
                  @keyup.native.enter="login"></el-input>
      </div>
    </div>
    <div class="login_info_box_item">
      <div style="display: flex;column-gap: 10px">
        <el-input placeholder="验证码" prefix-icon="el-icon-circle-check" v-model="code"
                  @keyup.enter.native="login"></el-input>
<!--        <Sidentify :identifyCode="identifyCode" @click.native="refreshCode"/>-->
        <img :src="captchaForm.captchaImage"
             alt="" style="width: 112px;height: 100%" @click="refreshCode"/>
      </div>
    </div>
    <div class="login_info_box_item">
      <b2b-button @click="login">{{ $t('login.login_btn') }}</b2b-button>
    </div>


    <el-dialog title="温馨提示" :visible.sync="showChangePwdDialog" width="550px"
               :close-on-click-modal="false" append-to-body>
      <div>
          <div style="color: #606266;margin-bottom: 15px">您的密码已超过90天未修改，为了您的安全，请修改密码后重新登录。</div>
          <el-form label-position="top" label-width="100px" :model="form" :rules="rules" ref="passForm">
            <el-form-item label="原密码" prop="oldPwd">
              <el-input v-model="form.oldPwd" type="password" show-password clearable
                        placeholder="请输入原密码"></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="newPwd">
              <el-input v-model="form.newPwd" type="password" show-password clearable
                        placeholder="大小写字母、数字和特殊字符中至少三种类型混合组成，长度8位以上"></el-input>
            </el-form-item>
            <el-form-item label="重复新密码" prop="confirmNewPassword">
              <el-input v-model="form.confirmNewPassword" type="password" show-password clearable
                        placeholder="请再次输入密码"></el-input>
            </el-form-item>
          </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" size="small" @click="forceChangePwd">确定修改</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
const crypto = require('crypto-js')
const JAVA_IV_BYTES = [8, 13, 20, 25, 33, 38, 47, 51, 89, 110, 127, 75, 86, 94, 100, 114]

const JDK8_KEY_HEX = "D3EEC0872D90DCFBA29AED1B81F192824E5CE2D281845B2DAE6CA62B14F39BD4"
const SECRET_KEY = crypto.enc.Hex.parse(JDK8_KEY_HEX)

export default {
  data () {
    let checkOldPwd = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入新密码'))
      } else {
        const regexList = [
          /[A-Z]/,          // 大写字母
          /[a-z]/,          // 小写字母
          /\d/,             // 数字
          /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/ // 常用特殊字符
        ]
        if (value.length < 8) {
          return callback(new Error('密码长度不能少于8位'))
        }
        const matchedTypes = regexList.filter(regex => regex.test(value)).length
        if (matchedTypes < 3) {
          return callback(new Error('请输入正确的密码格式'))
        }
        callback();
      }
    }
    let checkNewPwd = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请重复新密码'))
      } else {
        if (value === this.form.newPwd) {
          callback()
        } else {
          return callback(new Error('两次密码输入不一致'))
        }
      }
    }
    return {
      loginForm: {},
      identifyCode: '',
      identifyCodes: '0123456789',
      code: '',
      showChangePwdDialog: false,
      rules: {
        oldPwd: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
        newPwd: [{ required: true, validator: checkOldPwd, trigger: 'blur' }],
        confirmNewPassword: [{ required: true, validator: checkNewPwd, trigger: 'blur' }]
      },
      form: {},
      userInfo: {},
      captchaForm: {
        captchaId: '',
        captchaImage: ''
      },
    }
  },
  created () {
    this.refreshCode()
  },
  methods: {
    async login () {
      if (!this.loginForm.loginName) return this.$message.warning('请输入用户名')
      if (!this.loginForm.password) return this.$message.warning('请输入密码')
      if (!this.code) return this.$message.warning('请输入验证码')
      let req = {
        loginName: this.loginForm.loginName,
        password: this.makePassword(this.loginForm.loginName, this.loginForm.password),
        device: 'from b2b',
        captchaId: this.captchaForm.captchaId,
        captcha: this.code
      }
      const {data: result} = await this.$http.post('mini/loginByName', req)
      if (result.code !== 200) {
        this.handleErrPwd(result.data)
        this.refreshCode()
        return this.$message.error(result.message)
      }
      if (result.data.pwdUpdateDate) {
        if (this.isOver90Days(Date.now(), result.data.pwdUpdateDate)) {
          this.userInfo = result.data
          this.showChangePwdDialog = true
          return
        }
      }
      localStorage.setItem('partnerInfo', JSON.stringify(result.data))
      sessionStorage.removeItem('homeSearchForm')
      this.$router.push('/NewHome')
    },
    makePassword (username, password) {
      const pswEncrypt = `${username}-${password}`
      // 执行AES加密，参数与后端完全匹配
      const encrypted = crypto.AES.encrypt(pswEncrypt, SECRET_KEY, {
        iv: this.createIVFromJavaBytes(),
        mode: crypto.mode.CBC,
        padding: crypto.pad.Pkcs7 // PKCS5Padding与PKCS7Padding在AES中效果一致
      })
      // 转换为十六进制输出，与后端的DatatypeConverter.printHexBinary一致
      return encrypted.ciphertext.toString().toUpperCase()
    },
    createIVFromJavaBytes () {
      const words = []
      for (let i = 0; i < JAVA_IV_BYTES.length; i += 4) {
        words.push(
          ((JAVA_IV_BYTES[i] & 0xff) << 24) |
          ((JAVA_IV_BYTES[i + 1] & 0xff) << 16) |
          ((JAVA_IV_BYTES[i + 2] & 0xff) << 8) |
          (JAVA_IV_BYTES[i + 3] & 0xff)
        )
      }
      return crypto.lib.WordArray.create(words, JAVA_IV_BYTES.length)
    },
    isOver90Days (time1, time2) {
      // 将输入转换为Date对象
      const date1 = new Date(time1);
      const date2 = new Date(time2);

      // 验证时间有效性
      if (isNaN(date1.getTime()) || isNaN(date2.getTime())) {
        throw new Error('传入的时间格式无效')
      }

      // 计算时间差（取绝对值，避免顺序影响）
      const diffMs = Math.abs(date1.getTime() - date2.getTime())
      // 90天对应的毫秒数：90天 * 24小时 * 60分钟 * 60秒 * 1000毫秒
      const ninetyDaysMs = 90 * 24 * 60 * 60 * 1000

      return diffMs > ninetyDaysMs
    },
    forceChangePwd () {
      this.$refs.passForm.validate(async (valid) => {
        if (valid) {
          if (this.userInfo.personType === 1) {
            await this.changePwd()
          } else {
            await this.changeSubPwd()
          }
        }
      })
    },
    async changePwd () {
      let headerReq = {
        accessToken: this.userInfo.token
      }
      let req = {...this.form}
      req.updateWhat = 1
      const { data: result } = await this.$http.post('/mini/uptPartner', req, { headers: headerReq })
      if (result.code !== 200) return this.$message.error(result.message)
      this.$message.success('修改成功')
      this.showChangePwdDialog = false
    },
    async changeSubPwd () {
      let headerReq = {
        accessToken: this.userInfo.token
      }
      let req = {...this.form}
      req.updateWhat = 1
      const { data: result } = await this.$http.post('/mini/uptSubAccount', req, { headers: headerReq })
      if (result.code !== 200) return this.$message.error(result.message)
      this.$message.success('修改成功')
      this.showChangePwdDialog = false
    },
    handleErrPwd (pwdErrCount) {
      if (Number(pwdErrCount) === 5) {
        this.$confirm('用户名或密码不正确，您还可以尝试1次。为保证账户安全，连续错误6次将被临时锁定。', '登录失败', {
          showCancelButton: false,
          type: 'warning'
        })
      }
      if (Number(pwdErrCount) >= 6) {
        this.errorInfo = '账户已被锁定'
        this.$confirm('您已连续6次输入错误的用户名或密码，账户已被临时锁定30分钟，请稍后再尝试登录。', '账户已锁定', {
          showCancelButton: false,
          type: 'error'
        })
      }
    },
    refreshCode () {
      this.getCaptcha()
    },
    async getCaptcha () {
      const {data: result} = await this.$http.get('/mini/captcha')
      if (result.code !== 200) return this.$message.error(result.message)
      this.captchaForm = result.data
    },
    makeCode (l) {
      let length = this.identifyCodes.length
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[Math.floor(Math.random() * length)]
      }
    }
  }
}
</script>

<style lang="less" scoped>
.login_info_box {
  font-size: 14px;

  .login_info_box_item {
    display: grid;
    grid-auto-rows: auto auto;
    grid-row-gap: 10px;
    margin-bottom: 25px;
  }
}

/deep/ .el-dialog {
  border-radius: 8px;
}

/deep/ .el-dialog__header {
  border-radius: 8px;
  background-color: #fff;
  padding: 10px 20px;
  display: flex;
  align-items: center;
}

/deep/ .el-dialog__title {
  color: #606266;
  font-size: 18px;
  font-weight: 500;
}

/deep/ .el-dialog__body {
  padding: 10px 20px;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
  font-size: 18px;
}

/deep/ .el-dialog__headerbtn {
  height: 20px;
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/newPages/login/components/LoginByName.vue